import { Box, Typography, useTheme } from "@mui/material";
import { ScopeOfFinishingDisplay, Track } from "../../../types";
import EditScopeInfo from "./edit-scope-info";

export default function PropertyTrackScopeInfo({ track }: { track: Track }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        borderRadius: "12px",
        backgroundColor: "#FFFFFF",
        width: "100%",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              sx={theme.nawy.typography.english.variants.body.md.semibold}
            >
              Scope
            </Typography>
            <EditScopeInfo track={track} />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "40px",
              justifyContent: "start",
            }}
          >
            {track.scopeOfFinishing
              ? ScopeOfFinishingDisplay[track.scopeOfFinishing]
              : "N/A"}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
